
// Copyright (c) 2020 Deere & Company

import actions from '../../shared/actions-list';
import {getSapStatus} from '../../shared/repositories/sap-status';

const minimumTimeBetweenStatusChecks = 30000;

/* eslint-disable complexity */

export async function readSapStatus(store) {

    let sapStatus;

    sapStatus = store.getState().app.sapStatus;
    const sapStatusCurrent = sapStatus;

    if (sapStatus.lastChecked <= (Date.now() - minimumTimeBetweenStatusChecks)) {

        try {

            sapStatus = await getSapStatus();

            sapStatus.lastChecked = Date.now();

            store.dispatch({
                data: sapStatus,
                type: actions.UPDATE_SAP_STATUS
            });

        } catch (error) {

        }

    }

    if (sapStatusCurrent.isSapUp !== sapStatus.isSapUp && sapStatusCurrent.lastChecked > 0) {

        document.location.href = '/';

    }

}

/* eslint-enable complexity */



// WEBPACK FOOTER //
// ./src/app/action-creators/sap-status.js